import { Toggle } from '@/components/ui'
import DataContainer from '../../common/DataContainer'
import { formatDate } from '@/utils/formatters'

export default ({assurance, date_dernier_releve}) => (
  <div>
    <div className="grid grid-cols-[13rem_1fr] items-center gap-2">
      <div className="text-gray-600 whitespace-nowrap">Assurance :</div>
      <Toggle.Display labelSuffix="" className="mb-0" value={assurance} />
    </div>
    <DataContainer
      label="Assurance date"
      value={formatDate(date_dernier_releve)} >
      { !date_dernier_releve && <span className="text-error">Merci de nous faire parvenir votre justificatif d’assurance</span>}
    </DataContainer>
  </div>
)